<ion-button (click)="close()" color="light">
    <ion-icon slot="icon-only" name="close"></ion-icon>
</ion-button>